<template>
  <v-container class="pt-0" fluid>
    <div class="d-flex pb-3 bg--white" style="position: sticky; top: 116px; z-index: 1;">
      <h3 class="darken-1">검색결과 <span class="primary--text">{{ items.length }}</span></h3>
      <v-spacer />
      <div v-show="items.length > 0">
        <v-menu transition="scroll-y-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-btn text :ripple="false"
                   height="auto"
                   v-bind="attrs"
                   v-on="on"
            >
              <b>{{ sortOptions[sort].name }}</b>
              <v-icon color="secondary">mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list class="filter-list">
            <v-list-item-group v-model="sort" mandatory>
              <v-list-item v-for="(option, index) in sortOptions" :key="index"
                           link color="primary"
              >
                <v-list-item-title>{{ option.name }}</v-list-item-title>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>
        <v-btn x-small icon plain color="secondary" @click="$refs.filters.open()">
          <v-icon>
            mdi-tune-variant
          </v-icon>
        </v-btn>
      </div>
    </div>
    <div v-if="selected.length"
         class="library-filters-selected bg--white"
         style="position: sticky; top: 153px; z-index: 1;">
      <div class="filters">
        <ul>
          <li v-for="(btn, k) in selected" :key="`selected${k}`">
            <v-btn text plain color="secondary"
                   class="px-0 min-width-auto"
                   @click="$delete(selected, k)"
            >
              <b class="primary--text me-1">{{ btn.typeNm }}</b>
              <v-icon small>mdi-close</v-icon>
            </v-btn>
          </li>
        </ul>
      </div>
      <v-btn text plain color="secondary"
             class="px-0 min-width-auto ms-3"
             @click="selected = []"
      >
        <v-icon>
          mdi-reload
        </v-icon>
      </v-btn>
    </div>

    <Loading v-if="isLoading" :isLoading="isLoading"/>
    <!-- 리스트 없는 경우 -->
    <NoData v-else-if="items.length === 0"
            no-data-text="검색 결과가 없습니다."
    />
    <!-- 리스트 있는 경우 -->
    <template v-else>
      <LibraryItemList :items="items" />
    </template>

    <BottomSheet ref="filters" @change="handlerFilter">
      <template #default="{ close }">
        <v-card class="library-search-filters">
          <v-card-title>
            <v-tabs v-model="filterTab">
              <v-tab>주제별</v-tab>
              <v-tab>유형별</v-tab>
            </v-tabs>
            <v-spacer />
            <v-btn icon @click="close()"><IconClose /></v-btn>
          </v-card-title>
          <v-tabs-items v-model="filterTab">
            <v-tab-item>
              <v-list>
                <v-list-item v-for="(item, k) in optionsSubject" :key="`subject${k}`">
                  <v-checkbox
                      class="mt-0"
                      off-icon="mdi-check-circle-outline"
                      on-icon="mdi-check-circle"
                      v-model="filterSelected"
                      :value="item"
                  >
                    <template #label>
                      {{ item.typeNm }}
                      <b class="primary--text ms-1">({{ item.totalCount }})</b>
                    </template>
                  </v-checkbox>
                </v-list-item>
              </v-list>
            </v-tab-item>
            <v-tab-item>
              <v-list>
                <v-list-item v-for="(item, k) in optionsCategory" :key="`cate${k}`">
                  <v-checkbox
                      class="mt-0"
                      off-icon="mdi-check-circle-outline"
                      on-icon="mdi-check-circle"
                      v-model="filterSelected"
                      :value="item"
                  >
                    <template #label>
                      {{ item.typeNm }}
                      <b class="primary--text ms-1">({{ item.totalCount }})</b>
                    </template>
                  </v-checkbox>
                </v-list-item>
              </v-list>
            </v-tab-item>
          </v-tabs-items>
          <v-card-actions>
            <v-btn large block elevation="0" :depressed="false"
                   color="primary"
                   @click="setFilter(filterSelected); close()"
            >필터 적용</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </BottomSheet>
  </v-container>
</template>
<script>
import store from '@/store'
import LibraryItemList from './LibraryItemList.vue'

  const DEFAULT = () => {
  return {
    isLoading: false,
    sortOptions: [
      { cd: 'regDt', name: '최신순' },
      { cd: 'inqCnt', name: '조회수' },
      { cd: 'likeCnt', name: '좋아요' }
    ],
    sort: 0,
    items: [],
    optionsCategory: {},
    optionsSubject: {},
    selected: [],
    filterTab: 0,
    filterSelected: []
  }
}

export default {
  name: 'LibrarySearchResultNew',
  components: {
    LibraryItemList
  },
  props: {
    category: {
      type: Array
    }
  },
  data: () => ({
    ...DEFAULT()
  }),
  computed: {
    searchKeyword() {
      return this.$route.query.search
    }
  },
  watch: {
    // searchKeyword: {
    //   immediate: true,
    //   handler(nV) {
    //     if (nV) {
    //       console.log('searchKeyword')
    //       this.onSearch()
    //     }
    //   }
    // },
    selected () {
      this.onSearch()
    },
    sort () {
      this.onSearch()
    }
  },
  activated () {
    this.onSearch()
  },
  destroyed () {
    this.reset()
  },
  deactivated () {
    // $data 리셋 조건: 상세 -> 검색 결과 시에만 리셋하지 않음
    if(this.$route.path !== '/fo/library/view') this.reset()
  },
  methods: {
    handlerFilter (value) {
      if (value) this.filterSelected = [...this.selected]
    },
    setFilter (value) {
      this.selected = value
    },
    reset () {
      Object.assign(this.$data, DEFAULT())
    },
    async goSubjectDetail(subjectVal, subjectName) {
      // await this.$router.push({
      //   name: '도서관 상세',
      //   params: {'subjectNo': subjectVal, reload: true},
      //   query: {title: subjectName, sid: subjectVal, search:this.searchKeyword }
      // })
      this.$emit('onEvent', { fn: 'setView', params: 'SearchDetails' })
      await this.$router.push({
        name: 'LibrarySearch',
        params: {'subjectNo': subjectVal, reload: true},
        query: {title: subjectName, sid: subjectVal, search: this.searchKeyword }
      }).catch(() => {})
    },
    async onSearch() {
      const searchTypeItems = this.selected.filter(sel=>sel.kind==="TYPE").map(map=>map.type);
      const searchSubjectItems = this.selected.filter(sel=>sel.kind==="SUBJECT").map(map=>map.type);

      let params = [
        {searchOrderBy: this.sortOptions[this.sort].cd},
        {searchText: this.searchKeyword},
        {searchTypeItems},
        {searchSubjectItems},
        {searchTextOption: 'content'},
        {subjectLimit: null}
      ]
      this.isLoading = true
      await store.dispatch('getSearchLibraryList', this.$_payload('so', params))
        .then(res => {
          if (res.success) {
            const resultData = res.data.contents;

            // 검색된 item 내역에서 있는 주제만 필터 조건 만듬
            this.optionsSubject = res.data.subjectGroupItems;
            this.optionsCategory = res.data.typeGroupItems;

            this.items = resultData;
          } else {
            console.log('실패 = ', res.msg)
          }
          this.$emit('event', { fn: 'setCookie', params: { keyword: this.searchKeyword } })
        })
        .catch(() => {
          this.isLoading = false
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>
